module.exports = __webpack_public_path__ + "img/vue2-doublure_noir.d6244cb1.png";